import React from 'react';
import { Trash } from 'phosphor-react';
import { UserProduct } from '../../types/entities';
import { ActionModal, PrimaryButton } from '../index';
import { useUltimoValor } from '../../use/usePresence';

interface DeleteProductModalProps {
  product: UserProduct | null;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteProductModal({ product: produtoProp, onClose, onConfirm }: DeleteProductModalProps) {
  // O nome precisa continuar na tela enquanto o modal sai.
  const product = useUltimoValor(produtoProp);

  return (
    <ActionModal
      isOpen={Boolean(produtoProp)}
      onClose={onClose}
      title="Excluir produto"
      size="sm"
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-start gap-3 p-3 bg-red-50 dark:bg-red-900/20 rounded-xl border border-red-100 dark:border-red-800">
          <Trash className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-semibold text-red-700 dark:text-red-400">
              {product?.name}
            </p>
            <p className="text-xs text-red-500 dark:text-red-500 mt-0.5">
              Essa ação não pode ser desfeita.
            </p>
          </div>
        </div>
        <div className="flex gap-2">
          <PrimaryButton variant="outline" fullWidth onClick={onClose}>
            Cancelar
          </PrimaryButton>
          <button
            onClick={onConfirm}
            className="flex-1 py-3.5 bg-red-500 hover:bg-red-600 text-white text-sm font-semibold rounded-button transition-colors"
          >
            Excluir
          </button>
        </div>
      </div>
    </ActionModal>
  );
}
